import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ApisClientProvider } from '../Providers';
import { setMethodOverride } from './internal';
import { useWillMount } from '../../react-utils/Hooks';
export function createApiClientProvider(apiConfig) {
  const Provider = _ref => {
    let {
      children,
      httpClient,
      refetchOverrides,
      overrides = {},
      ...defaultQueryOptions
    } = _ref;
    useWillMount(() => {
      const prevOverrides = {};
      Object.keys(overrides).forEach(methodName => {
        const methodConfig = apiConfig[methodName];
        if (!methodConfig) {
          return;
        }
        const override = overrides[methodName];
        prevOverrides[methodName] = setMethodOverride(methodConfig, override, refetchOverrides);
      });
      return () => {
        Object.keys(prevOverrides).forEach(methodName => {
          const methodConfig = apiConfig[methodName];
          if (!methodConfig) {
            return;
          }
          const prevOverride = prevOverrides[methodName];
          setMethodOverride(methodConfig, prevOverride, refetchOverrides);
        });
      };
    });
    return /*#__PURE__*/React.createElement(ApisClientProvider, _extends({
      httpClient: httpClient
    }, defaultQueryOptions), children);
  };
  return Provider;
}
//# sourceMappingURL=createApiClientProvider.js.map